import CustomScrollbar from 'components/CustomScrollbar';
import styled from 'styled-components';
import { mediaBreakpointUp } from 'styles/grid';

const desktopBreakpoint = mediaBreakpointUp.sm;

export const ContentContainer = styled(CustomScrollbar)`
  padding: 24px 16px;
  ${desktopBreakpoint} {
    max-height: 500px;
    overflow-y: auto;
  }
`;
